import styled from 'styled-components';

export const DwtcVirtualIndustryGlobalIndustryWrapper = styled.section`
  background-color: #fff;
  padding-bottom: 80px;
  @media (max-width: 992px) {
    padding-bottom: 50px;
  }
`;
export const DwtcVirtualIndustryGlobalIndustryContainer = styled.div`
  max-width: 1120px;
  margin: 0px auto;
  position: relative;
  @media (max-width: 1199px) {
    max-width: 100%;
    padding: 0px 15px;
  }
`;
export const DwtcVirtualIndustryGlobalIndustryBody = styled.div`
  border: 1px solid #ebebeb;
  padding: 30px;
  @media (max-width: 767px) {
    padding: 15px;
  }
`;
export const DwtcVirtualIndustryGlobalIndustryTitle = styled.div`
  font-size: 16px;
  line-height: 26px;
  strong {
    color: #000;
  }
  p {
    margin: 0px;
    font-size: 15px;
  }
  @media (max-width: 767px) {
    font-size: 14px;
    line-height: 24px;
    p {
      font-size: 14px;
    }
  }
`;
export const DwtcVirtualIndustryGlobalIndustrySlider = styled.div`
  padding-top: 40px;
  padding-left: 56px;
  padding-right: 56px;

  @media (max-width: 1300px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  @media (max-width: 992px) {
    padding-left: 15px;
    padding-right: 15px;
  }
  @media (max-width: 576px) {
    padding-left: 0px;
    padding-right: 0px;
  }
  .swiper-wrapper {
    justify-content: center;
    @media (max-width: 1200px) {
      justify-content: start;
    }
  }
`;
export const DwtcVirtualIndustryGlobalIndustrySliderImage = styled.div`
  img {
    width: inherit;
    height: 28px;
    object-fit: contain;
  }
`;
